module.exports = __webpack_public_path__ + "img/138.1.35eb4d17.jpg";